const ProjectMapSkeleton = () => (
  <div className='relative w-full h-[500px] md:h-[800px] overflow-hidden rounded-[10px]'>
    <div className='absolute inset-0 -translate-x-full animate-shimmer bg-linear-to-r from-transparent via-white/10 to-transparent' />
  </div>
)

export default ProjectMapSkeleton
